/* globals grecaptcha */

import $ from 'jquery'

const debug = require('debug')('pm:recaptcha')

type RecaptchaCallback = () => void

let internalRecaptchaCallback: RecaptchaCallback | null = null

export function executeRecaptcha(callback: RecaptchaCallback) {
  debug('executing reCAPTCHA')

  internalRecaptchaCallback = callback

  grecaptcha.execute()
}

export function isRecaptchaEnabled() {
  return (
    typeof grecaptcha !== 'undefined' &&
    typeof grecaptcha.execute === 'function'
  )
}

// callback for google reCAPTCHA
// eslint-disable-next-line @typescript-eslint/no-explicit-any, no-extra-semi
;(window as any).__handleRecaptchaCallback =
  function __handleRecaptchaCallback() {
    debug('recaptcha passed')
    if (!internalRecaptchaCallback)
      throw new Error('Recaptcha callback not set!')

    internalRecaptchaCallback()
  }

$(function setupRecaptcha() {
  const $form = $('.js-recaptcha-form')
  if (!$form.length) return

  function submitForm() {
    $form.off('submit.recaptcha').submit()
  }

  $form.on('submit.recaptcha', function handleSubmit(event) {
    debug('submit form')

    event.preventDefault()

    if (isRecaptchaEnabled()) {
      executeRecaptcha(submitForm)
    } else {
      submitForm()
    }
  })

  debug('loaded')
})
